// Feed items - content discovered and saved by the user
export const feedItems = [
  {
    id: 1,
    type: 'article_summary',
    source: 'Wait But Why',
    sourceUrl: 'https://waitbutwhy.com/2017/04/neuralink.html',
    sourceClipId: 1,
    sourceClipTitle: 'Neuralink and the Brain\'s Magical Future',
    contentType: 'summarized',
    timestamp: '1h ago',
    date: 'Feb 2, 2026',
    author: 'Tim Urban',
    avatar: '🧠',
    title: 'Neuralink and the Brain\'s Magical Future',
    subtitle: 'The Wizard Era: Merging with AI',
    content: 'An epic deep-dive into Elon Musk\'s Neuralink. The article traces the evolution of the nervous system from jellyfish to humans, explains how brain-machine interfaces work, and explores a future where humans merge with AI. Neuralink wants to redefine what future humans will be.',
    interests: ['Neuralink', 'Brain-Machine Interface', 'Neuroscience', 'AI', 'Elon Musk', 'Future Technology'],
    aiGenerated: false,
    socialLinks: [
      { 
        platform: 'Twitter', 
        author: 'waitbutwhy',
        snippet: 'The Neuralink post took 6 weeks to research and write. It\'s the hardest thing I\'ve ever tried to explain - but also the most exciting.',
        url: 'https://twitter.com/waitbutwhy/status/example',
        engagement: { likes: 45200, comments: 1890, shares: 12400 }
      },
      { 
        platform: 'Hacker News', 
        author: 'neuroscientist',
        snippet: 'Tim Urban does it again. This is the most accessible explanation of BCIs I\'ve ever read. The jellyfish-to-human evolution section is brilliant.',
        url: 'https://news.ycombinator.com/item?id=example',
        engagement: { likes: 2340, comments: 567 }
      },
      { 
        platform: 'Reddit', 
        author: 'futurology_mod',
        snippet: 'r/Futurology: This Wait But Why piece on Neuralink is essential reading. The "Wizard Era" concept changed how I think about human-AI integration.',
        url: 'https://reddit.com/r/Futurology/comments/neuralink_wbw',
        engagement: { likes: 34500, comments: 2100 }
      }
    ],
    relatedNews: [
      {
        title: 'Neuralink receives FDA approval for human trials',
        source: 'MIT Technology Review',
        timestamp: '2h ago',
        type: 'breakthrough',
        url: 'https://example.com/neuralink-fda'
      },
      {
        title: 'First Neuralink patient plays chess with mind',
        source: 'Wired',
        timestamp: '1d ago',
        type: 'milestone',
        url: 'https://example.com/neuralink-chess'
      }
    ]
  },
  {
    id: 2,
    type: 'podcast',
    source: 'All-In Podcast',
    sourceUrl: 'https://open.spotify.com/episode/791OEmQezfdouGHkCBJdDK',
    sourceClipId: 2,
    sourceClipTitle: 'All-In\'s 2026 Predictions',
    contentType: 'summarized',
    timestamp: '2h ago',
    date: 'Feb 1, 2026',
    author: 'All-In Podcast',
    avatar: '🎙️',
    title: 'All-In\'s 2026 Predictions',
    subtitle: 'Chamath, Jason, Sacks & Friedberg',
    content: 'The besties make their bold predictions for 2026 covering politics, business, and markets. Topics include the California exodus and asset seizure tax, biggest political and business winners/losers, most contrarian beliefs, best and worst performing assets, and most anticipated trends.',
    interests: ['Venture Capital', 'Politics', 'Economics', 'Tech Industry', 'Predictions', 'Markets'],
    aiGenerated: false,
    socialLinks: [
      { 
        platform: 'Twitter', 
        author: 'chaaborhood',
        snippet: 'The All-In predictions episode is always my favorite of the year. Sacks\' contrarian bet on energy is bold but I think he\'s right.',
        url: 'https://twitter.com/chaaborhood/status/example',
        engagement: { likes: 8900, comments: 342, shares: 1200 }
      },
      { 
        platform: 'Reddit', 
        author: 'venture_watcher',
        snippet: 'r/startups: The besties\' take on AI valuations vs reality is spot on. This bubble feels different but the fundamentals matter.',
        url: 'https://reddit.com/r/startups/comments/allin_predictions',
        engagement: { likes: 4500, comments: 890 }
      },
      { 
        platform: 'Twitter', 
        author: 'marketwatch',
        snippet: 'All-In podcast hosts predict major market shifts in 2026. Their track record on tech predictions has been notably accurate.',
        url: 'https://twitter.com/marketwatch/status/example',
        engagement: { likes: 12300, comments: 567, shares: 2100 }
      }
    ],
    relatedNews: [
      {
        title: 'Google founders face California wealth tax debate',
        source: 'New York Times',
        timestamp: '1d ago',
        type: 'policy',
        url: 'https://www.nytimes.com/2026/01/09/technology/google-founders-california-wealth-tax.html'
      },
      {
        title: 'Atlanta Fed doubles Q4 GDP estimate to 5.4%',
        source: 'TipRanks',
        timestamp: '3h ago',
        type: 'economy',
        url: 'https://tipranks.com/news/atlanta-fed-doubles-q4-gdp-estimate'
      }
    ]
  }
];

// Platform icons and colors for source attribution
export const platformIcons = {
  'Wait But Why': '🤔',
  'Spotify': '🎧',
  'Wikipedia': '📚',
  'Substack': '📝',
  'Reddit': '🔴',
  'Nature': '🔬',
  'X (Twitter)': '𝕏',
  'LinkedIn': '💼',
  'Biography.com': '👤',
  'Scientific American': '🧪',
  'YouTube': '📺',
  'Medium': '📄',
  'The Atlantic': '🌊',
  'New York Times': '📰',
  'Wired': '⚡',
  'MIT Technology Review': '🎓',
  'ArXiv': '📊',
  'Hacker News': '🟠'
};

export const platformColors = {
  'Wait But Why': 'bg-cyan-100 text-cyan-800 border-cyan-200',
  'Spotify': 'bg-green-100 text-green-800 border-green-200',
  'Wikipedia': 'bg-gray-100 text-gray-800 border-gray-200',
  'Substack': 'bg-orange-100 text-orange-800 border-orange-200',
  'Reddit': 'bg-red-100 text-red-800 border-red-200',
  'Nature': 'bg-blue-100 text-blue-800 border-blue-200',
  'X (Twitter)': 'bg-black text-white border-gray-300',
  'LinkedIn': 'bg-blue-100 text-blue-800 border-blue-200',
  'Biography.com': 'bg-purple-100 text-purple-800 border-purple-200',
  'Scientific American': 'bg-green-100 text-green-800 border-green-200',
  'YouTube': 'bg-red-100 text-red-800 border-red-200',
  'Medium': 'bg-gray-100 text-gray-800 border-gray-200',
  'The Atlantic': 'bg-blue-100 text-blue-800 border-blue-200',
  'New York Times': 'bg-gray-100 text-gray-800 border-gray-200',
  'Wired': 'bg-yellow-100 text-yellow-800 border-yellow-200',
  'MIT Technology Review': 'bg-red-100 text-red-800 border-red-200',
  'ArXiv': 'bg-green-100 text-green-800 border-green-200',
  'Hacker News': 'bg-orange-100 text-orange-800 border-orange-200'
};

// Interest categories for tagging and organization
export const interestCategories = {
  'Science & Technology': {
    color: 'blue',
    icon: '🔬',
    subcategories: ['Physics', 'Chemistry', 'Biology', 'AI', 'Space Exploration']
  },
  'History & Culture': {
    color: 'green',
    icon: '🏛️',
    subcategories: ['Renaissance', 'Ancient History', 'Art History', 'Literature']
  },
  'People & Biographies': {
    color: 'purple',
    icon: '👤',
    subcategories: ['Scientists', 'Artists', 'Historical Figures', 'Innovators']
  },
  'Philosophy & Ideas': {
    color: 'orange',
    icon: '💭',
    subcategories: ['Ethics', 'Logic', 'Critical Thinking', 'Social Issues']
  },
  'Media & Entertainment': {
    color: 'pink',
    icon: '🎬',
    subcategories: ['Movies', 'Books', 'Music', 'Documentaries']
  }
};